import queryClient from "single-spa/react-app/query-client";

export const getVerticalFromLobName = (selectedSite: string) => {
    const cachedLobSites = queryClient.getQueryData<{ Site: string; Vertical: string }[]>(["lob-sites"]);
    const lobVertical = cachedLobSites?.find((lob) => lob.Site === selectedSite)?.Vertical;
    return lobVertical;
};

type LobBarChartData = {
    Data?: {
        [domain: string]: {
            LobAnalysis?: {
                [lobName: string]: {
                    LobKey?: string;
                };
            };
        };
    };
};

export const getLobKeyFromLobName = (lobName: string | null | undefined): string | null => {
    if (!lobName) {
        return null;
    }

    const queryCache = queryClient.getQueryCache();
    const allQueries = queryCache.findAll({ queryKey: ["lob-bar-chart"] });

    for (const query of allQueries) {
        const cachedData = query.state.data as LobBarChartData | undefined;

        if (!cachedData?.Data) {
            continue;
        }

        for (const domain in cachedData.Data) {
            const lobAnalysis = cachedData.Data[domain]?.LobAnalysis;
            if (lobAnalysis?.[lobName]?.LobKey) {
                return lobAnalysis[lobName].LobKey;
            }
        }
    }

    return null;
};

export const getFirstFromCommaSeparated = (value?: string): string => {
    if (!value) {
        return "";
    }

    return value.split(",")[0].trim();
};
